import React, { useEffect, useState } from "react";
import { Table } from "antd";
import Highlighter from "react-highlight-words";

const TableCoreTeam = (props) => {
  const [coreTeamInfo, setCoreTeamInfo] = useState(props.coreTeamInfo);
  useEffect(() => {
    setCoreTeamInfo(props.coreTeamInfo);
  }, [props.coreTeamInfo]);
  const columns = [
    {
      title: "Stt",
      dataIndex: "stt",

      sorter: (a, b) => a.stt - b.stt,
    },
    {
      title: "Main Address",
      dataIndex: "mainAddress",
      render: (text) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[props.valueSearch]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ),
      filterSearch: true,
    },
    {
      title: "Role",
      dataIndex: "role",
    },
    {
      title: "Active",
      dataIndex: "roleValue",
      render: (roleValue) => {
        return <span>{roleValue ? "👍" : "❌"}</span>;
      },
    },
    {
      title: "Referral Address",
      dataIndex: "referralAddress",
      render: (text) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[props.valueSearch]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ),
    },
    {
      title: "Other Address",
      dataIndex: "otherAddress",
      render: (otherAddress) => {
        return otherAddress.map((text) => (
          <p>
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[props.valueSearch]}
              autoEscape
              textToHighlight={text ? text.toString() : { text }}
            />
          </p>
        ));
      },
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={coreTeamInfo}
        rowKey="stt"
        pagination={{ pageSize: 5 }}
      />
    </div>
  )
};

export default TableCoreTeam;
